
import "./Footer.css";

import React from 'react'

const Footer = () => {
  return (
    <div className="Footer">
      © Respected Owners
    </div>
  )
}

export default Footer
